import { DeepPartial, NextQueriesSuggestionsConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_NEXT_QUERY_SUGGESTIONS: DeepPartial<NextQueriesSuggestionsConfig> = {
  components: {
    item: 'CdlNextQuerySuggestion'
  },
  size: 10
};
